import { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { StoreContext } from '../containers/Store';

const Logout = (props) => {
  const {
    user: {
      user,
      storeUser,
    }
  } = useContext(StoreContext);
  user.roles = ['ADMIN_DEMO'];
  storeUser({ user: {...user }});
  localStorage.removeItem('evidenceB-user');
  window.location.replace('/');
  return null;
}

export default withRouter(Logout);